import React from 'react';
import { NavigateBack } from '../../generic/LinkWithDirectionalArrow';

const PreviousStep = ({ onClick }) => {
  return <NavigateBack onClick={onClick}>Previous Step</NavigateBack>;
};

export default PreviousStep;
